import { useUserActiveOrganization } from "@/api";
import { OrganizationApps } from "@/features/organization-apps";
import { createFileRoute } from "@tanstack/react-router";

type GalleryFilter = {
  filterName?: string | undefined;
  filterShowPublicApps?: boolean;
};

export const Route = createFileRoute(
  "/_auth/_fixed-sidebar/_organization-access/organization/$organizationSlug/gallery"
)({
  component: Gallery,
  validateSearch: (search: Record<string, unknown>): GalleryFilter => ({
    filterName: (search.filterName as string) || undefined,
    filterShowPublicApps: (search.filterShowPublicApps as boolean) || undefined
  })
});

function Gallery() {
  const { activeOrganization } = useUserActiveOrganization();
  return (
    <OrganizationApps
      organizationName={activeOrganization?.name}
      organizationSlug={activeOrganization?.slug}
    />
  );
}
